import React from 'react';
import { Zap, TrendingUp, DollarSign, Shield, Target, Layers } from 'lucide-react';

const Benefits = () => {
  const benefits = [
    {
      icon: Zap,
      title: 'Automatización',
      description: 'Automatizamos tareas repetitivas y optimizamos procesos logísticos y tiempos de trabajo.'
    },
    {
      icon: TrendingUp,
      title: 'Incremento de productividad',
      description: 'Impulsamos el rendimiento de los equipos simplificando y agilizando actividades.'
    },
    {
      icon: DollarSign,
      title: 'Reducción de costes',
      description: 'Minimizamos los costes operativos identificando áreas de mejora y optimización.'
    },
    {
      icon: Shield,
      title: 'Mejora de la seguridad',
      description: 'Analizamos datos para identificar amenazas y supervisamos sistemas con tecnología avanzada.'
    },
    {
      icon: Target,
      title: 'Predicción y mantenimiento',
      description: 'Prevenimos fallos, reduciendo tiempo de inactividad y costes de reparaciones.'
    },
    {
      icon: Layers,
      title: 'Escalabilidad',
      description: 'Manejamos mayores volúmenes de trabajo y datos sin aumentar los recursos humanos.'
    }
  ];

  return (
    <section id="benefits" className="py-24 bg-gradient-to-b from-white to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Automatizamos, optimizamos e innovamos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transformamos la manera en que operan las empresas, abriendo nuevas oportunidades de crecimiento
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={index}
                className="group relative bg-gradient-to-br from-white to-white rounded-xl p-8 border border-gray-200 hover:border-[#ff6b35] transition-all duration-300 hover:shadow-xl hover:shadow-[#ff6b35]/10 hover:-translate-y-1"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-[#ff6b35]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl"></div>
                
                <div className="relative">
                  <div className="inline-flex items-center justify-center w-14 h-14 bg-orange-50 rounded-lg mb-4 group-hover:bg-[#ff6b35] transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                    <Icon className="w-7 h-7 text-[#ff6b35] group-hover:text-gray-900" />
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#ff6b35] transition-colors">
                    {benefit.title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-white to-orange-50 rounded-2xl p-12 border border-[#ff6b35]/30">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Preparamos empresas más conectadas, más inteligentes y más productivas
            </h3>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
              En un entorno empresarial cada vez más dinámico, nuestras soluciones tecnológicas son la clave para impulsar el crecimiento y adaptarse rápidamente a los cambios del mercado.
            </p>
            <button className="bg-[#ff6b35] hover:bg-[#f97316] text-gray-900 px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-[#ff6b35]/30">
              Conocer más
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;